import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=48793792&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48793792",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48793792')) {
      api.createRecord('48793792', component.options)
    } else {
      api.reload('48793792', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=48793792&scoped=true&", function () {
      api.rerender('48793792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27NOgR4O4bprm/JS/comp/Voucher-Unit.vue"
export default component.exports